import { useEffect, useState } from 'react';
import { first } from 'rxjs/operators';
import { useParams } from 'react-router';

import { useDataRequestsApiContext } from '@vivli/core/infrastructure/context';
import { NotFoundComponent } from '@vivli/shared/components';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { DataRequestShellFeature } from './data-request-shell.feature';

// this feature is for use with data requests accessed
// by vivliId (via direct url access)
export const DataRequestByVivliIdFeature = () => {
    // requestId here is intentionally the Vivli ID value from the route:
    // /adminDataRequests/vivliId/:requestId
    const { requestId } = useParams();
    const { getDataRequestByVivliId } = useDataRequestsApiContext();

    const [dataRequest, setDataRequest] = useState<IDataRequest>();
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        if (!requestId) {
            setNotFound(true);
            return;
        }

        const sub = getDataRequestByVivliId(requestId)
            .pipe(first())
            .subscribe({
                next: setDataRequest,
                error: () => setNotFound(true)
            });

        return () => {
            sub.unsubscribe();
        };
    }, [requestId, getDataRequestByVivliId]);

    if (notFound) {
        return <NotFoundComponent />;
    }

    if (!dataRequest) {
        return <LoadIndicatorCenteredView />;
    }

    return <DataRequestShellFeature dataRequest={dataRequest} />;
};
